var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/types/route-group-items.enum.ts
var route_group_items_enum_exports = {};
__export(route_group_items_enum_exports, {
  RouteGroupItemSideloading: () => RouteGroupItemSideloading,
  RouteGroupItemStatus: () => RouteGroupItemStatus
});
module.exports = __toCommonJS(route_group_items_enum_exports);
var RouteGroupItemStatus = /* @__PURE__ */ ((RouteGroupItemStatus2) => {
  RouteGroupItemStatus2[RouteGroupItemStatus2["Inspected"] = 4] = "Inspected";
  RouteGroupItemStatus2[RouteGroupItemStatus2["Done"] = 3] = "Done";
  RouteGroupItemStatus2[RouteGroupItemStatus2["NotFinished"] = 2] = "NotFinished";
  RouteGroupItemStatus2[RouteGroupItemStatus2["NotStarted"] = 1] = "NotStarted";
  RouteGroupItemStatus2[RouteGroupItemStatus2["Else"] = 0] = "Else";
  return RouteGroupItemStatus2;
})(RouteGroupItemStatus || {});
var RouteGroupItemSideloading = /* @__PURE__ */ ((RouteGroupItemSideloading2) => {
  RouteGroupItemSideloading2["RouteGroup"] = "routeGroup";
  RouteGroupItemSideloading2["Car"] = "car";
  RouteGroupItemSideloading2["Driver"] = "driver";
  RouteGroupItemSideloading2["Loader"] = "loader";
  RouteGroupItemSideloading2["Loader2"] = "loader2";
  RouteGroupItemSideloading2["User"] = "user";
  RouteGroupItemSideloading2["Base"] = "base";
  RouteGroupItemSideloading2["Region"] = "region";
  RouteGroupItemSideloading2["Weight"] = "weight";
  return RouteGroupItemSideloading2;
})(RouteGroupItemSideloading || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RouteGroupItemSideloading,
  RouteGroupItemStatus
});
